export default __webpack_public_path__ + "static/media/Template-SampleCSV.f7462ae3.png";